import {CSSProperties, ReactElement} from "react";
import css from "./css.module.scss";
import cn from "classnames";
import {COLORS} from "../../constants/Colors";

export interface BarLoaderProps {
    loading: boolean;
    color?: string;
    position?: "top" | "bottom";
    zIndex?: number;
    positionStatic?: boolean;
}
// displays an infinite animating loader bar similar to material ui loader
// places itself at the top or bottom of its first relative parent and spans 100% width
export default function BarLoader({loading, color, position, zIndex, positionStatic}: BarLoaderProps): ReactElement {
    const positionCSS = position === "bottom" ? "bottom" : "top";

    const style: CSSProperties = {};
    if (positionStatic) {
        style.position = "static";
        if(!loading) {
            style.display = "none";
        }
    } else {
        style[positionCSS] = 0;
    }
    if(typeof zIndex === "number") {
        style.zIndex = zIndex;
    }

    return (
        <div className={cn(css.wrapper, loading && css.isVisible)} style={style}>
            <div className={css.line} style={{background: color ?? COLORS.PRIMARY_500}}></div>
            <div className={cn(css.subline, css.inc)} style={{background: color ?? COLORS.PRIMARY_500}}></div>
            <div className={cn(css.subline, css.dec)} style={{background: color ?? COLORS.PRIMARY_500}}></div>
        </div>
    );
}
